import MasterOrganizeSettingLayout from './MasterOrganizeSettingLayout';

export default MasterOrganizeSettingLayout;
